export const GuideContract  = {
    async index_by_client_guides(client_id, per_page, page, status) {
        client_id;
        per_page;
        page;
        status;
        throw new Error("index_by_client_guides not implemented");
    },
    
    async get_guide(data) {
        data;
        throw new Error("get_guide not implemented");
    },

    async create_guide(data) {
        data;
        throw new Error("create_guide not implemented");
    },

    async donwload_guides(ids) {
        ids;
        throw new Error("donwload_guides not implemented");
    },

    async delete_guides(ids) {
        ids;
        throw new Error("delete_guides not implemented");
    },

    async cancel_guides(ids) {
        ids;
        throw new Error("cancel_guides not implemented");
    },
    
    async get_blob(path) {
        path;
        throw new Error("get_blob not implemented");
    },

    async donwload_history_report(client_id, initial_date, final_date) {
        client_id;
        initial_date;
        final_date;
        throw new Error("donwload_history_report not implemented");
    },

    async load_payments(data) {
        data;
        throw new Error("load_payments not implemented");
    }
}